import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


	
	
export default /*#__PURE__*/_defineComponent({
  __name: 'OperationBtn',
  props: {
		text: {
			type: String,
			default: ""
		}
	},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

	
	
	const emits = __emit;
	
	const Submit = () => {
		emits("change");
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "add-btn-2",
      type: "primary",
      plain: "",
      onClick: Submit
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.text), 1)
      ]),
      _: 1
    })
  ]))
}
}

})